import { render, staticRenderFns } from "./KeywordLandingPage.vue?vue&type=template&id=333935ee&scoped=true"
import script from "./KeywordLandingPage.vue?vue&type=script&lang=js"
export * from "./KeywordLandingPage.vue?vue&type=script&lang=js"
import style0 from "./KeywordLandingPage.vue?vue&type=style&index=0&id=333935ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "333935ee",
  null
  
)

export default component.exports